// src/components/TabMenu.jsx
import React from "react";

export default function TabMenu({ tabs, activeTab, onChange, ariaLabel }) {
  return (
    <div
      className="flex space-x-4 border-b border-border mb-4"
      role={ariaLabel ? "tablist" : undefined}
      aria-label={ariaLabel}
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.key;
        return (
          <button
            key={tab.key}
            type="button"
            role={ariaLabel ? "tab" : undefined}
            aria-selected={ariaLabel ? isActive : undefined}
            aria-controls={ariaLabel ? `tabpanel-${tab.key}` : undefined}
            id={ariaLabel ? `tab-${tab.key}` : undefined}
            className={[
              "pb-2 px-3 text-base font-medium transition-colors border-b-2 focus:outline-none",
              isActive
                ? "border-brand text-brand"
                : "border-transparent text-muted hover:text-app",
            ].join(" ")}
            onClick={() => onChange(tab.key)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
